import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { css, cx } from "@/styled-system/css";
import { Card, Text, Box, Paragraph } from "@zillow/constellation-10";
import { useFormContext } from "react-hook-form";
import { getWholeDollars } from "../../utils/zhl-calculator.esm.js";
import { useLastValidFormValues } from "./LoanComparison.utils.esm.js";
const OUTPUTS = [{
  label: "Monthly payment",
  accessor: "monthlyPayment"
}, {
  label: "Total principal",
  accessor: "totalPrincipal"
}, {
  label: "Total interest",
  accessor: "totalInterest"
}, {
  label: "Pay-off date",
  accessor: "payOffDate"
}];
const resultPanelClassName = css({
  backgroundColor: "gray.50",
  paddingInline: "default",
  // SkunkWorks v8 `radii.sm` = 12px → `radii.obj.default` (not `obj.sharp` / 4px; generic v8-tokens sm→sharp is wrong for this theme).
  borderRadius: "{radii.obj.default}",
  overflow: "hidden"
});
const resultRowClassName = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  paddingBlock: "default"
});
const resultRowBorderClassName = css({
  borderBottom: "2px solid {colors.border.muted}"
});
const LoanComparisonResultCard = (props) => {
  return /* @__PURE__ */ jsxs(Card, { elevated: false, tone: "neutral", css: {
    flex: 1
  }, children: [
    /* @__PURE__ */ jsx(Text, { textStyle: "heading-sm", css: {
      textAlign: "center",
      paddingBottom: "loose"
    }, asChild: true, children: /* @__PURE__ */ jsx("p", { children: props.headingText }) }),
    /* @__PURE__ */ jsx(Box, { className: resultPanelClassName, children: OUTPUTS.map(({
      label,
      accessor
    }, index) => {
      const isLastOutput = index !== OUTPUTS.length - 1;
      return /* @__PURE__ */ jsxs(Box, { className: cx(resultRowClassName, isLastOutput && resultRowBorderClassName), children: [
        /* @__PURE__ */ jsx(Paragraph, { children: label }),
        /* @__PURE__ */ jsx(Text, { textStyle: "heading-sm", css: {
          paddingLeft: "{spacing.default}",
          textAlign: "right"
        }, children: getWholeDollars(props.lastValidValues[props.loanType][accessor]) })
      ] }, accessor);
    }) })
  ] });
};
const LoanComparisonResultForm = () => {
  const form = useFormContext();
  const lastValidValues = useLastValidFormValues(form);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(LoanComparisonResultCard, { loanType: "typeOneCalculations", headingText: "Loan 1", lastValidValues }),
    /* @__PURE__ */ jsx(LoanComparisonResultCard, { loanType: "typeTwoCalculations", headingText: "Loan 2", lastValidValues }),
    /* @__PURE__ */ jsx(LoanComparisonResultCard, { loanType: "typeThreeCalculations", headingText: "Loan 3", lastValidValues })
  ] });
};
export {
  LoanComparisonResultCard,
  LoanComparisonResultForm as default
};
